export default __webpack_public_path__ + "static/1-46f69c575d393229ba0ff3483a32ee49.webp";